// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Import jQuery
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// app/javascript/packs/application.js
import 'bootstrap';
import './serviceworker-companion';
import './pwa-buttom';
import './loading';
import './sidebar';
import './nested_fields';
import './subscription';
import '../page_loader';

Rails.start()
Turbolinks.start()
ActiveStorage.start()
